function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import styled from "styled-components";
import { ButtonPrimary } from "../../";
export const ButtonInstagram = ({
  children,
  ...props
}) => {
  return React.createElement(ButtonInstagramWrap, _extends({}, props, {
    iconLeft: React.createElement("svg", {
      width: "16px",
      height: "16px",
      viewBox: "0 0 32 32",
      version: "1.1"
    }, React.createElement("g", {
      id: "Logos",
      stroke: "none",
      "stroke-width": "1",
      fill: "#ffffff",
      "fill-rule": "evenodd"
    }, React.createElement("g", {
      id: "Logo/Third-Party/Instagram/Reversed"
    }, React.createElement("path", {
      d: "M9.125,0 L22.875,0 C27.9145983,-9.25759197e-16 32,4.08540166 32,9.125 L32,22.875 C32,27.9145983 27.9145983,32 22.875,32 L9.125,32 C4.08540166,32 6.17172798e-16,27.9145983 0,22.875 L0,9.125 C-6.17172798e-16,4.08540166 4.08540166,9.25759197e-16 9.125,0 Z M9.125,2.875 C5.67322031,2.875 2.875,5.67322031 2.875,9.125 L2.875,22.875 C2.875,26.3267797 5.67322031,29.125 9.125,29.125 L22.875,29.125 C26.3267797,29.125 29.125,26.3267797 29.125,22.875 L29.125,9.125 C29.125,5.67322031 26.3267797,2.875 22.875,2.875 L9.125,2.875 Z M16,24.1875 C11.4781686,24.1875 7.8125,20.5218314 7.8125,16 C7.8125,11.4781686 11.4781686,7.8125 16,7.8125 C20.5218314,7.8125 24.1875,11.4781686 24.1875,16 C24.1875,20.5218314 20.5218314,24.1875 16,24.1875 Z M16,21.3125 C18.9340127,21.3125 21.3125,18.9340127 21.3125,16 C21.3125,13.0659873 18.9340127,10.6875 16,10.6875 C13.0659873,10.6875 10.6875,13.0659873 10.6875,16 C10.6875,18.9340127 13.0659873,21.3125 16,21.3125 Z M24.515625,9.40625 C23.4542027,9.40625 22.59375,8.54579725 22.59375,7.484375 C22.59375,6.42295275 23.4542027,5.5625 24.515625,5.5625 C25.5770473,5.5625 26.4375,6.42295275 26.4375,7.484375 C26.4375,8.54579725 25.5770473,9.40625 24.515625,9.40625 Z",
      id: "path-1"
    }))))
  }), children);
};
export const ButtonInstagramWrap = styled(ButtonPrimary)`
  background-color: ${props => props.theme.colors.instagram};
  color: #ffffff;

  &:hover,
  &:focus {
    background-color: ${props => props.theme.colors.instagram};
    box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.24), 0 0 8px 0 rgba(0, 0, 0, 0.32);
  }
`;